import React from 'react'

const Filter = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/filter',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill={primaryColor}
      fillRule='evenodd'
    >
      <path d='M18 4.6c0 .331-.358.6-.8.6H2.8c-.442 0-.8-.269-.8-.6 0-.331.358-.6.8-.6h14.4c.442 0 .8.269.8.6M15 9.6c0 .331-.299.6-.667.6H5.667C5.299 10.2 5 9.931 5 9.6c0-.331.299-.6.667-.6h8.666c.368 0 .667.269.667.6M12 14.6c0 .331-.15.6-.333.6H8.333c-.184 0-.333-.269-.333-.6 0-.331.15-.6.333-.6h3.334c.184 0 .333.269.333.6' />
    </g>
  </svg>
)

export default Filter
